module.exports = __webpack_public_path__ + "static/treder2-aab83bed06d18a5300e6d0a34dacc762.svg";